class t {
  iban(a) {
    switch (a.slice(0, 2)) {
      case "AD":
        return "aa99 9999 9999 9999 9999 9999";
      case "AE":
        return "aa99 9999 9999 9999 9999 999";
      case "AL":
        return "aa99 9999 9999 9999 9999 9999 9999";
      case "AT":
        return "aa99 9999 9999 9999 9999";
      case "AZ":
        return "aa99 aaaa 9999 9999 9999 9999 9999";
      case "BA":
        return "aa99 9999 9999 9999 9999";
      case "BE":
        return "aa99 9999 9999 9999";
      case "BG":
        return "aa99 aaaa 9999 9999 9999 99";
      case "BH":
        return "aa99 aaaa 9999 9999 9999 99";
      case "BR":
        return "aa99 9999 9999 9999 9999 9999 999a 9";
      case "CR":
        return "aa99 9999 9999 9999 9999 9";
      case "CH":
        return "aa99 9999 9999 9999 9999 9";
      case "CY":
        return "aa99 9999 9999 9999 9999 9999 9999";
      case "CZ":
        return "aa99 9999 9999 9999 9999 9999";
      case "DE":
        return "aa99 9999 9999 9999 9999 99";
      case "DK":
        return "aa99 9999 9999 9999 99";
      case "DO":
        return "aa99 aaaa 9999 9999 9999 9999 9999";
      case "EE":
        return "aa99 9999 9999 9999 9999";
      case "ES":
        return "aa99 9999 9999 9999 9999 9999";
      case "FI":
        return "aa99 9999 9999 9999 99";
      case "FO":
        return "aa99 9999 9999 9999 99";
      case "FR":
        return "aa99 9999 9999 9999 9999 9a99 999";
      case "GB":
        return "aa99 aaaa 9999 9999 9999 99";
      case "GE":
        return "aa99 aa99 9999 9999 9999 99";
      case "GI":
        return "aa99 aaaa 9999 9999 9999 999";
      case "GL":
        return "aa99 9999 9999 9999 99";
      case "GR":
        return "aa99 9999 9999 9999 9999 9999 999";
      case "GT":
        return "aa99 aaaa 9999 9999 9999 9999 9999";
      case "HR":
        return "aa99 9999 9999 9999 9999 9";
      case "HU":
        return "aa99 9999 9999 9999 9999 9999 9999";
      case "IE":
        return "aa99 aaaa 9999 9999 9999 99";
      case "IL":
        return "aa99 9999 9999 9999 9999 999";
      case "IS":
        return "aa99 9999 9999 9999 9999 9999 99";
      case "IT":
        return "aa99 a999 9999 9999 9999 9999 999";
      case "KW":
        return "aa99 aaaa 9999 9999 9999 9999 9999 99";
      case "KZ":
        return "aa99 999a aa99 9999 9999";
      case "LB":
        return "aa99 9999 9999 9999 9999 9999 9999";
      case "LI":
        return "aa99 9999 9999 9999 999a a";
      case "LT":
        return "aa99 9999 9999 9999 9999";
      case "LU":
        return "aa99 9999 9999 9999 9999";
      case "LV":
        return "aa99 aaaa 9999 9999 9999 9";
      case "MC":
        return "aa99 9999 9999 9999 9999 9999 a99";
      case "MD":
        return "aa99 aa99 9999 9999 9999 9999";
      case "ME":
        return "aa99 9999 9999 9999 9999 99";
      case "MK":
        return "aa99 9999 9999 9999 999";
      case "MR":
        return "aa99 9999 9999 9999 9999 9999 999";
      case "MT":
        return "aa99 aaaa 9999 9999 9999 aaaa aaa9 99a";
      case "MU":
        return "aa99 aaaa 9999 9999 9999 9999 999a aa";
      case "NL":
        return "aa99 aaaa 9999 9999 99";
      case "NO":
        return "aa99 9999 9999 999";
      case "PK":
        return "aa99 aaaa 9999 9999 9999 9999";
      case "PL":
        return "aa99 9999 9999 9999 9999 9999 9999";
      case "PS":
        return "aa99 aaaa 9999 9999 9999 9999 9999 9";
      case "PT":
        return "aa99 9999 9999 9999 9999 9999 9";
      case "RO":
        return "aa99 aaaa 9B99 9999 9999 9999";
      case "RS":
        return "aa99 9999 9999 9999 9999 99";
      case "SA":
        return "aa99 9999 9999 9999 9999 9999";
      case "SE":
        return "aa99 9999 9999 9999 9999 9999";
      case "SI":
        return "aa99 9999 9999 9999 999";
      case "SK":
        return "aa99 9999 9999 9999 9999 9999";
      case "SM":
        return "aa99 a999 9999 9999 9999 9999 999";
      case "TN":
        return "aa99 9999 9999 9999 9999 9999";
      case "TR":
        return "aa99 9999 9999 9999 9999 9999 99";
      case "VG":
        return "aa99 aaaa 9999 9999 9999 9999";
      default:
        return "aa99 aaaa 9999 9999 99";
    }
  }
}
export {
  t as default
};
